<template>


    <div>
        <v-app>
            <v-skeleton-loader v-if="loading" type="article, article"></v-skeleton-loader>
            <!-- <v-parallax v-if="dtBasvuruSuresiBitti" dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg">
                <v-row align="center" justify="center">
                    <v-col class="text-center" cols="12">
                        <h1 class="text-h4 font-weight-thin mb-4">
                            Form Yönetim Sistemi
                        </h1>
                        <h4 class="subheading">
                            Başvuru yapmaya çalıştığınız form son başvuru tarihini geçtiğinden dolayı yayından
                            kaldırılmıştır.
                        </h4>
                    </v-col>
                </v-row>
            </v-parallax> -->

            <v-container v-if="dtUyari" class="fill-height d-flex justify-center align-center" fluid>
                <v-card elevation="12" class="pa-6" max-width="500" width="100%">
                    <v-card-title class="headline success--text justify-center">
                        {{ errorMessage.header }}
                    </v-card-title>

                    <v-card-text class="text-center">
                        <p>{{ errorMessage.label }}</p>

                        <v-btn color="primary"
                            :to="{ name: 'KullaniciLogin', params: { id: $route.params.id } }">Sisteme
                            Giriş</v-btn>
                        <!-- <v-alert border="left" colored-border type="success" elevation="2" class="mt-4 text-left">
                            <div><strong>Başvuru Numarası:</strong> #202507230001 </div>
                            <div><strong>Tarih:</strong> 23 Temmuz 2025</div>

                        </v-alert> -->
                    </v-card-text>

                    <!-- <v-card-actions class="justify-center mt-4">
        <v-btn color="success" dark @click="$router.push('/')">
          Ana Sayfaya Dön
        </v-btn>
      </v-card-actions> -->
                </v-card>
            </v-container>

            <!-- <ul>
                <li v-for="field in fields" :key="field.id">
                    {{ field.id }}-
                    {{ field.value }}
                </li>
            </ul> -->

            <!-- <ul>
                <li v-for="(key, value) in saltData" :key="key">
                    {{ key }}-
                    {{ value }}
                </li>
            </ul> -->

            <v-card v-if="taslakShow && taslakServerValid && !loading && !dtUyari">
                <v-toolbar color="light-blue" dark>
                    <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

                    <v-toolbar-title>Taslaklarım</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="taslakSave">
                        <v-icon>mdi-invoice-text-plus</v-icon>
                    </v-btn>
                    <!--
      <v-btn icon>
        <v-icon>mdi-view-module</v-icon>
      </v-btn> -->
                </v-toolbar>

                <v-list subheader two-line>
                    <v-subheader inset>Formunuzu taslak olarak kaydedebilirsiniz.Daha sonra "Forma Yansıt" diyerek
                        taslağı Formunuza yansıtabilirsiniz.</v-subheader>

                    <v-list-item v-for="taslak in taslaks" :key="taslak.id">
                        <!-- <v-list-item-action>
                            <v-btn icon @click="taslakYansit(taslak.value)">
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                        </v-list-item-action> -->

                        <v-list-item-content>
                            <v-list-item-title>{{ taslak.aciklama }}
                            </v-list-item-title>

                            <v-list-item-subtitle >Oluşturulma Tarihi: {{ formatDate(taslak.olusturulmaTarihi) }}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <!-- <v-btn icon @click="taslakYansit(taslak.value)">
            <v-icon color="grey lighten-1">mdi-information</v-icon>
          </v-btn>-->
                            <v-menu bottom left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>

                                <v-list>
                                    <v-list-item @click="taslakGuncelle(taslak)">
                                        <v-list-item-icon><v-icon>mdi-table-edit</v-icon></v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Güncelle</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="taslakDelete(taslak.taslakId)">
                                        <v-list-item-icon><v-icon>mdi-delete-sweep</v-icon></v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Form Sil</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                                            <v-list-item @click="taslakYansit(taslak.value)">
                                        <v-list-item-icon><v-icon>mdi-folder-arrow-up-down-outline</v-icon></v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Forma Yansıt</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-list-item-action>
                    </v-list-item>

                    <v-divider inset></v-divider>


                </v-list>
            </v-card>



            <!-- <ul>
                <li v-for="taslak in taslaks" :key="taslak.id">
                    <v-btn @click="taslakGuncelle(taslak.taslakId)" color="success">Güncelle</v-btn>
                    {{ formatDate(taslak.olusturulmaTarihi) }} Tarihli Taslak <v-btn @click="taslakYansit(taslak.value)"
                        color="success">Yansıt</v-btn>
                </li>

                <li><v-btn @click="taslakSave" color="success">Kaydet</v-btn></li>
            </ul> -->

            <v-form ref="frmItems" v-if="!loading && !dtUyari" class="my-5">


                <v-row>

                    <!-- <v-col v-for="field in fields" :key="field.id"   cols="12"
                    :md="field.cols || 12"
                    :sm="field.cols || 12"
                    :lg="field.cols || 12"
                    :xl="field.cols || 12"
                    >

                        <component v-model="field.value" v-bind:is="field.cmpName" :ayar="field" :rules="field.rules"
                            @triggerEvent="triggerEvent">
                        </component>
                    </v-col> -->
                    <!-- v-if="checkVisibility(field)"  -->

                    <v-col v-for="field in NotGroupFields" :key="field.id" cols="12" :md="field.cols || 12"
                        :sm="field.cols || 12" :lg="field.cols || 12" :xl="field.cols || 12">

                        <div v-if="field.grpName" class="xyz my-1 mx-1  pa-4 v-card v-sheet theme--light">
                        
                            <component v-model="field.value" v-bind:is="field.cmpName" :ayar="field" :edit="edit"
                                :rules="field.rules" @triggerEvent="triggerEvent">
                                <template v-slot:group>
                                    <v-row>
                                        <v-col v-for="fieldItem in listGrpNameFieldByGrpName(field.grpName)" cols="12"
                                            :md="fieldItem.cols || 12" :sm="fieldItem.cols || 12"
                                            :lg="fieldItem.cols || 12" :xl="fieldItem.cols || 12" :key="fieldItem.id">
                                            <div>
                                                
                                                <component v-model="fieldItem.value" v-bind:is="fieldItem.cmpName"
                                                    :edit="edit" :ayar="fieldItem" :rules="fieldItem.rules"
                                                    @triggerEvent="triggerEvent">
                                                </component>
                                            </div>

                                        </v-col>
                                    </v-row>

                                </template>

                            </component>
                        </div>
                        <div v-else class="xyz my-1 mx-1  pa-4 v-card v-sheet theme--light">
                           
                            <component v-model="field.value" v-bind:is="field.cmpName" :ayar="field"
                                :rules="field.rules" :edit="edit" @triggerEvent="triggerEvent">
                            </component>
                        </div>



                    </v-col>


                </v-row>



                <v-list subheader two-line class="my-5">


                    <!-- <v-list-item v-for="(field) in fields" :key="field.id">

             

                        <v-list-item-content class="pa-2">



                            <component v-model="field.value" v-bind:is="field.cmpName" :ayar="field"
                                :rules="field.rules" @triggerEvent="triggerEvent">
                            </component>





                        </v-list-item-content>



                    </v-list-item> -->
                    <v-list-item>
                        <v-list-item-content>
                            <table>

                                <tr>

                                    <td style="width: 100px;">
                                        <div><span style="font-size: small; margin-bottom: 5px;">Güvenlik Kodu: </span>
                                        </div>
                                        <img :src="captchaImage" style="width: 100px; height: 40px;" alt="Captcha" />
                                    </td>
                                    <td style="width: 35px;"> <v-btn icon class="mx-2" fab dark color="teal"
                                            @click="loadCaptcha"><v-icon>mdi-refresh</v-icon></v-btn></td>
                                    <td><v-text-field :rules="rules" label="Güvenlik Kodu"
                                            v-model="userInputCaptha"></v-text-field>
                                    </td>
                                </tr>
                            </table>





                        </v-list-item-content>
                    </v-list-item>

                </v-list>

                <v-card-actions v-if="actionVisible">
                    <v-spacer></v-spacer>


                    <v-btn block color="primary" @click="dataSend()">
                        Kaydet
                    </v-btn>
                    <!-- <v-btn block color="primary" @click="dataSendDeneme()">
                        Kaydet
                    </v-btn> -->
                </v-card-actions>
            </v-form>
        </v-app>




    </div>


</template>
<script>
//import { rules } from '@/plugins/custom.js'
import { numberSF, textSF, radioSF, selectSF, dateSF, mailSF, checkSF } from '@/plugins/FieldDataFormat.js'
import FormService from '@/services/FormService'
import TaslakService from '@/services/TaslakService';
import VText from '@/components/field_types/VText.vue';
import VNumber from '@/components/field_types/VNumber.vue';
import VRadio from '@/components/field_types/VRadio.vue';
import VSelect from '@/components/field_types/VSelect.vue';
import VDate from '@/components/field_types/VDate.vue';
import VMail from '@/components/field_types/VMail.vue';
import VCheck from '@/components/field_types/VCheck.vue';
import VHtmlEditor from '@/components/field_types/VHtmlEditor.vue';
import VFile from '@/components/field_types/VFile.vue';
import VCheckMatrix from './field_types/VCheckMatrix.vue';
import VRadioMatrix from './field_types/VRadioMatrix.vue';
import VTextMatrix from './field_types/VTextMatrix.vue';
import VDateHtml from './field_types/VDateHtml.vue';
import axios from 'axios';
import router from '@/router';
import { ValueTurEnum } from '@/plugins/Enum';
import { VBtn } from 'vuetify/lib';
//import api from '@/plugins/axios';
export default {
    components: {
        VText, VNumber, VRadio, VSelect, VDate, VMail, VCheck, VHtmlEditor, VFile, VCheckMatrix, VRadioMatrix, VTextMatrix, VDateHtml
    },
    name: 'FormViewRun2',
    props: {
        edit: { type: Boolean, default: false },
        actionVisible: { type: Boolean, default: true },
        formSavedId: { type: String, default: "" },
        formId: { type: String, default: "" },


    },
    data: () => ({
        taslakShow: false,
        taslaks: [],
        taslakServerValid:false,

        url: "",
        btnRedirectLogin: false,
        errorMessage: { header: "", label: "" },
        dtUyari: false,
        dtBasvuruSuresiBitti: false,
        loading: true,
        rules: [v => !!v || 'Boş Bırakılamaz.'],
        fields: [],
        captchaImage: null,
        userInputCaptha: null,

        itemTypeList: [
            textSF,
            numberSF,
            radioSF,
            selectSF,
            dateSF,
            mailSF,
            checkSF,


        ]

    }),
    created() {
        // this.validate()
//console.log("Route",console.log(this.$route.path););  
//console.log("Route", this.$route);
if (this.taslakShow && this.taslakServerValid && !this.loading && !this.dtUyari) {
    this.taslakServerValid=true;
      this.listTaslaks();
}
        this.dataBind()
        this.loadCaptcha();
    },
    watch: {

        formSavedId(n, o) {
            this.dataBind();
        },
        formId(n, o) {
            this.dataBind();
        }
        // selectedField: {
        //     immediate: true,
        //     handler() {

        //     },
        //     deep: true
        // }
    },
    computed: {

        saltData() {

            const formData = new FormData();
            let currentDataItems = this.fields.filter(m => !["html", "checkMatrix", "radioMatrix", "file"].includes(m.type));



            let matrixCheckList = this.fields.filter(m => m.type == "checkMatrix");
            let matrixRadioList = this.fields.filter(m => m.type == "radioMatrix");

            let matrixList = [];
            matrixCheckList.forEach(element => {
                element.rows.forEach(elementRow => {
                    let row = { id: elementRow.id, value: elementRow.value.join(",") };

                    matrixList.push(row);
                });

            });
            matrixRadioList.forEach(element => {
                element.rows.forEach(elementRow => {
                    let row = { id: elementRow.id, value: elementRow.value };

                    matrixList.push(row);
                });

            });

            currentDataItems.forEach(element => {
                formData.append(element.id, element.value);
            });


            matrixList.forEach(element => {
                formData.append(element.id, element.value);
            });
            const obj = Object.fromEntries(formData.entries());
            return obj;

        },
        listItems() {
            const result = Object.groupBy(this.fields, ({ grpName }) => grpName);
            return result;
        },
        NotGroupFields() {

            let result = this.fields.filter(x => !x.grpName || (!!x.grpName && x.type == "html"));

            result.forEach(obj => {

                if (!Object.prototype.hasOwnProperty.call(obj, "visibleIf")) {

                    obj.visibleIf = { goster: "goster", logic: "AND", conditions: [] };
                }

            });

            result = result.filter(field => this.checkVisibility(field));
            //const result2 = this.fields.filter(x => !!x.grpName && x.type == "html");

            return result;
            //return [...result, ...result2];
        },
        getUrl() {

            return process.env.VUE_APP_APIURL

        },

        validateDurumu() {


            // let value={id:this.$route.params.id,colums:fields.map(m=>({id:m.id,value:m.value}))};

            // console.log("object",value);



            return this.$refs.frmItems;
            // return   this.$refs.frmItems.validate();
        }
    },
    methods: {
        formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleString("tr-TR", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        },

        checkVisibility(field) {

            if (field.visibleIf.conditions.length == 0) {
                return true;
            }


            // if (!field.visibleIf) {
            //     return false;
            // } else {
            //     if (field.visibleIf.conditions.length == 0) {
            //         return false;
            //     }

            // }


            const evaluateGroup = (group) => {
                const { logic = "AND", conditions = [] } = group;

                const results = conditions.map(cond => {
                    if (cond.conditions) {
                        // Nested group

                        return evaluateGroup(cond);
                    } else {
                        // Tek koşul
                        // console.log("this.formData",this.fields,cond.field);
                        // console.log("this.Find",this.fields.find(m => m.id.localeCompare(cond.field) ));

                        const targetObject = this.fields.find(m => m.id.localeCompare(cond.field) == 0);
                        // console.log("cond.fieldxx", cond.field);
                        // console.log("Fields", this.fields);
                        // console.log("targetObjectcc", targetObject);
                        const targetValue = targetObject.value;// [cond.field];
                        // console.log("Fields", this.fields);
                        // console.log("cond.field", cond.field);
                        const { operator = "equals", value } = cond;
                        // console.log("Secili Combobox", targetValue, "Text", value, "--,", targetValue === value, "-------------", field.value);
                        switch (operator) {
                            case "equals": return targetValue === value;
                            case "notEquals": return targetValue !== value;
                            case "contains": return targetValue && targetValue.toString().includes(value);
                            case "greater": return Number(targetValue) > Number(value);
                            case "greaterOrEqual": return Number(targetValue) >= Number(value);
                            case "less": return Number(targetValue) < Number(value);
                            case "lessOrEqual": return Number(targetValue) <= Number(value);
                            default: return true;
                        }
                    }
                });

                return logic === "AND"
                    ? results.every(Boolean)
                    : results.some(Boolean);
            };
            if (field.visibleIf.goster == "gizle" && evaluateGroup(field.visibleIf)) {
                field.value = "";
            }

            return field.visibleIf.goster == "goster" ? evaluateGroup(field.visibleIf) : !evaluateGroup(field.visibleIf);
        },
        listGrpNameFieldByGrpName(grpName) {
            let selected = this.fields.filter(m => m.type != "html" && m.grpName == grpName)
            selected = selected.filter(field => this.checkVisibility(field));
            return selected;
        },
        reset() {
            console.log("Form reset Çalıştı",);
            this.$refs.frmItems.reset();
        },
        loadCaptcha() {


            axios.get(process.env.VUE_APP_APIURL + '/api/captcha/generate', {
                withCredentials: true, // session için gerekli

            }
            ).then((result) => {
                console.log("loadCaptcha", result);
                this.captchaImage = result.data.image;
                // this.$toast.success("Başarılı bir şekilde kaydedilmiştir.")
            }).catch((err) => {
                this.$toast.warning(err)
            });



            // const res = fetch('https://localhost:7211/api/captcha/generate', {
            //     credentials: 'include' // session için gerekli
            // });
            // res.then((result) => {
            //     console.log("loadCaptcha", result);
            //     const data = result.json();
            //     this.captchaImage = data.image;
            // }).catch((err) => {

            // });


        },



        async dataSend() {






            // console.log("validate:", this.$refs.frmItems.validate());




            //  eslint-disable-next-line vue/no-constant-condition
            const form = this.$refs.frmItems;
            // if (false) {
            if (form.validate()) {
                const formData = new FormData();
                let currentDataItems = this.fields.filter(m => !["html", "checkMatrix", "radioMatrix"].includes(m.type));



                let matrixCheckList = this.fields.filter(m => m.type == "checkMatrix");
                let matrixRadioList = this.fields.filter(m => m.type == "radioMatrix");
                let matrixList = [];
                matrixCheckList.forEach(element => {
                    element.rows.forEach(elementRow => {
                        let row = { id: elementRow.id, value: elementRow.value.join(",") };

                        matrixList.push(row);
                    });

                });
                matrixRadioList.forEach(element => {
                    element.rows.forEach(elementRow => {
                        let row = { id: elementRow.id, value: elementRow.value };

                        matrixList.push(row);
                    });

                });

                //console.log("matrixList", matrixList);

                currentDataItems.forEach(element => {

                    if (element.type == "file") {
                        if (Array.isArray(element.value)) {
                            element.value.forEach(itemFile => {
                                //console.log("ID", element.id, "ItemFile", itemFile);
                                formData.append(element.id, itemFile);
                            });
                        }
                        else {
                            formData.append(element.id, element.value);
                        }
                    }

                    else {
                        formData.append(element.id, element.value);
                    }


                });


                matrixList.forEach(element => {
                    formData.append(element.id, element.value);
                });




                let url = process.env.VUE_APP_APIURL + '/api/form/upload-dynamic/' + this.$route.params.id;
                if (this.edit) {
                    url = process.env.VUE_APP_APIURL + '/api/form/upload-dynamicEdit/' + this.$route.params.id
                }


                try {
                    const returnApi = await axios.post(url, formData, {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'code': this.userInputCaptha,


                        }
                    });
              
                     this.$emit("saveClick", returnApi);

      console.log("SAve", formData);



                } catch (err) {

                    this.$toast.warning(err.response.data)

                }
            }
            else {

                // Hatalı alanları bul
                this.$nextTick(() => {
                    const errorInputs = form.$el.querySelectorAll('.v-input.error--text input, .v-input.error--text textarea')
                    if (errorInputs.length > 0) {
                        errorInputs[0].focus()
                    }
                })
                return


            }







        },
        listTaslaks() {
            TaslakService.listTaslaks(this.$route.params.id).then((result) => {
                this.taslaks = result.data;
              
            }).catch((err) => {
               // this.taslakServerValid=false;
                //this.$toast.error("Hata oluştu.");
            });

        },
        taslakYansit(value) {

            let cvp = confirm("Taslak bilgilerini form üzerine yansıtmak istediğinize emin misiniz?")
            if (!cvp) {
                return false;
            }


            let currentDataItems = this.fields.filter(m => !["html", "checkMatrix", "radioMatrix", "file"].includes(m.type));

            let taslakValue = JSON.parse(value);
            this.fields.forEach(element => {
                if (element.id in taslakValue)
                {
                    element.value = taslakValue[element.id];
                }
            });


            let matrixCheckList = this.fields.filter(m => m.type == "checkMatrix");
            let matrixRadioList = this.fields.filter(m => m.type == "radioMatrix");
            let matrixTextList = this.fields.filter(m => m.type == "textMatrix");
            let matrixList = [];
            matrixCheckList.forEach(element => {
                element.rows.forEach(elementRow => {
                    // let row = { id: elementRow.id, value: elementRow.value.join(",") };
                    if (elementRow.id in taslakValue) {
                        elementRow.value = taslakValue[elementRow.id];
                    }
                    //  matrixList.push(row);
                });

            });
            matrixRadioList.forEach(element => {
                element.rows.forEach(elementRow => {
                    //let row = { id: elementRow.id, value: elementRow.value };
                    if (elementRow.id in taslakValue) {
                        elementRow.value = taslakValue[elementRow.id];
                    }
                    // matrixList.push(row);
                });

            });
            matrixTextList.forEach((element,index) => {
                let currentTaslakValue = null;
                if (element.id in taslakValue) {
                    currentTaslakValue = JSON.parse(taslakValue[element.id]);
           
           
                    // element.rows = currentTaslakValue;
                    console.log("element.rows",element.rows);
                    element.rows.forEach(elementRow => {
                        if (currentTaslakValue instanceof Array) {
                            let currentRow = currentTaslakValue.find(m => m.id == elementRow.id);
                             console.log("Key",currentRow);
                            console.log("Key",currentRow);
                            if (currentRow != undefined) {
                                elementRow.values = currentRow.values;
                                // console.log("Key2",currentRow);
                                // console.log("elementRow",elementRow);
                                // Object.keys(elementRow.values).forEach(key => {
                                //     console.log("Key3",key);
                                //       if (key in currentRow) {
                                //         elementRow.values[key] = currentRow[key]; // obj1’in değerini obj2 ile eşitle
                                //     }
                                // });



                               


                            }
                        }
                    })

                }

                // element.rows.forEach(elementRow => {
                //     //let row = { id: elementRow.id, value: elementRow.value };
                //     if (elementRow.id in taslakValue) {
                //         console.log("elementRow",taslakValue[elementRow.id]);
                //         //elementRow.value = taslakValue[elementRow.id];
                //     }
                //     // matrixList.push(row);
                // });

            });
            this.$toast.success("Taslak bilgileri başarılı bir şekilde yansıtılmıştır.");

        },
        taslakSave() {
            let cvp = prompt("Taslak Açıklaması Giriniz.")
            if (cvp) {
                TaslakService.insert({ formId: this.$route.params.id, Value: JSON.stringify(this.saltData),aciklama:cvp }).then((result) => {
                    this.taslaks = result.data;
                    this.$toast.success("Başarılı bir şekilde kaydedilmiştir.");
                    this.listTaslaks();
                }).catch((err) => {

                });
            }
            else
            {
                 this.$toast.warning("Açıklama boş bırakılamaz .");
            }
           
        },
        taslakGuncelle(taslak) {
            //console.log("TaslakID:", { value: JSON.stringify(this.saltData) });
           // let cvp = confirm("Form bilgileri var olan taslak bilgilerinizin üzerine yazılarak güncellenecektir.Devam etmek istediğinize emin misiniz?")
          // console.log("Taslak:",taslak); 
           let cvp = prompt("Taslak Açıklaması Giriniz.",taslak.aciklama)
           if (cvp) {

                TaslakService.update(taslak.taslakId, { value: JSON.stringify(this.saltData),aciklama:cvp }).then((result) => {
                    // this.taslaks = result.data;
                    this.listTaslaks();
                    this.$toast.success("Form bilgileri başarılı bir şekilde taslağa aktarılmıştır.");


                }).catch((err) => {

                });
            }
            else
            {
                  this.$toast.warning("Açıklama boş bırakılamaz .");
            }
        },
        taslakDelete(taslakId) {

            //console.log("TaslakID:", { value: JSON.stringify(this.saltData) });
            let cvp = confirm("Taslağı silmek istediğinize  emin misiniz?")
            if (cvp) {

                TaslakService.delete(taslakId).then((result) => {
                    // this.taslaks = result.data;
                    this.listTaslaks();
                    this.$toast.success("Taslak başarılı bir şekilde silinmiştir.");


                }).catch((err) => {

                });
            }
        },
        
        dataBind() {

          


            let this2 = this;

            let api = null;

            //console.log("Edit Null mu", this.edit);
            if (this.edit) {

                //api =  FormService.listFormItemsEdit(this.$route.params.id);
                api = FormService.listFormItemsEdit(this.formSavedId);
            }
            else {
                if (!this.actionVisible) {
                    api = FormService.listOnIzlemeFormItems(this.formId);
                }
                else {
this.taslakShow=true;
                    api = FormService.listFormItems(this.formId);
                }

            }





            api.then(function (response) {
                //console.log("DAta bind:", response.data);
                this2.dtUyari = false;
                this2.loading = false;
               // console.log("response.data2", response.data);
                if (response.data.length > 0) {
                    let edits = response.data;
                    let matrixRowsJson = edits.filter(m => m.valueTur == ValueTurEnum.MatrixRow);//.map(x => JSON.parse(x.json));
                    // console.log("matrixRowsJson", matrixRowsJson);
                    edits = edits.filter(m => m.valueTur != ValueTurEnum.MatrixRow);


                    edits = edits.map(m => {
                        //let value = JSON.parse(m.json); value.value = m.value;
                        const jsonObj = JSON.parse(m.json);
                        let itemEdit = null;

                        if (jsonObj.type == "textMatrix" && m.value) {

                            let updatedRows = JSON.parse(m.value);//Kaydedilen Değerler
                            let DataColums = [];
                            if (!jsonObj.dynamicRowAddAllow) {
                                if (m.value) {





                                    jsonObj.rows.forEach(row => {
                                        const updated = updatedRows.find(r => r.id === row.id);

                                        if (updated != undefined) {
                                            let newRow = { name: updated.name, id: updated.id, values: {} };
                                            jsonObj.columns.forEach(elementCol => {
                                                //console.log("updated.values",updated.values,elementCol,updated.values[elementCol]);
                                                newRow.values[elementCol.id] = updated.values[elementCol.id];
                                            });
                                            DataColums.push(newRow);
                                        }

                                    });

                                    jsonObj.rows = DataColums;
                                    // jsonObj.rows = jsonObj.rows.map(row => {
                                    //     const updated = updatedRows.find(r => r.id === row.id);

                                    //     return updated ? { ...row, values: updated.values, name: updated.name || row.name } : row;
                                    // });
                                }





                            }
                            else {
                                updatedRows.forEach(updated => {
                                    // const updated = updatedRows.find(r => r.id === row.id);

                                    if (updated != undefined) {
                                        let newRow = { name: updated.name, id: updated.id, values: {} };
                                        jsonObj.columns.forEach(elementCol => {

                                            newRow.values[elementCol.id] = updated.values[elementCol.id];
                                        });
                                        DataColums.push(newRow);
                                    }

                                });
                                jsonObj.rows = DataColums;

                            }

                        }




                        if (m.valueTur == ValueTurEnum.Matrix) {
                            for (let index = 0; index < jsonObj.rows.length; index++) {

                                let row = matrixRowsJson.find(x => JSON.parse(x.json).id == jsonObj.rows[index].id);
                                if (row != undefined) {
                                    let matrixJson = JSON.parse(row.json);

                                    if (matrixJson.type == "checkMatrix") {
                                        jsonObj.rows[index].value = row.value.split(',');
                                    }
                                    else {
                                        jsonObj.rows[index].value = row.value
                                    }




                                }


                            }

                            itemEdit = {
                                json: JSON.stringify(jsonObj),
                                value: m.value,
                                valueTur: m.valueTur
                                // valueTur: m.valueTur,
                            };
                        }
                        else {
                            itemEdit = {
                                json: JSON.stringify(jsonObj),
                                value: m.value,
                                valueTur: m.valueTur
                                // valueTur: m.valueTur,
                            };
                        }
                        // console.log("itemEdit", itemEdit);
                        return itemEdit;


                        //                    console.log("JSON STR:", m.json);
                        // const parsed = JSON.parse(m.json);
                        // console.log("PARSED:", parsed);

                        //  parsed.value = m.value;
                        //  console.log("VALUE:", parsed.value);
                        // return parsed;


                        // return value 
                    });
                    console.log("edits 22", edits);
                    console.log("Fiels:", this2.fields);
                    this2.fields = edits.map(m => { let json = JSON.parse(m.json); json.value = m.value; return json });
                    console.log("Fiels:", this2.fields);
                    //this2.fields = response.data.map(m => { let json = JSON.parse(m.json); json.value = m.value; return json });
                }
                else {
                    this2.fields = [];
                }



            }).catch((err) => {
                console.log("Error:", err);
                //this2.errorMessage = err.response.data;
                this2.loading = false;
                this2.dtUyari = true;
            });
        },
        triggerEvent(e) {
            // console.log("triggerEvent Parameter", e.id);
            let triggeredItem = this.fields.find(m => m.id == e.id);
            // console.log("triggerEvent triggeredItem", triggeredItem);
            triggeredItem.store = [...e.values];
        },

    }

}
</script>
<style scoped>
.theme--light.v-application {
    background: none !important;
}
</style>
